import { createSlice } from "@reduxjs/toolkit";
import { MAIN_NAV_KEYS } from "./MainNavConfig";

const initialState = {
    navbarType: MAIN_NAV_KEYS.DEFAULT
}

export const sliceName = "MainNav"

export const MainNavSlice = createSlice({
    name: sliceName,
    initialState,
    reducers: {
        setNavbarType: (state, action) => {
            state.navbarType = action.payload.navbarType
        }
    }
})


export const { setIsWhatWeOfferShown, setNavbarType } = MainNavSlice.actions

export const selectNavBarType = state => state[sliceName].navbarType

export default MainNavSlice.reducer